import { createContext, useContext, useEffect, useState } from "react";

// Create User Context
const UserContext = createContext();

export const UserProvider = ({ children }) => {
    const [user, setUser] = useState(() => {
        // Initialize from localStorage
        const savedUser = localStorage.getItem("USER");
        return savedUser ? JSON.parse(savedUser) : {}
    });

    // Update localStorage whenever user state changes
    useEffect(() => {
        localStorage.setItem("USER", JSON.stringify(user));
    }, [user]);

    return (
        <UserContext.Provider value={{ user, setUser }}>
            {children}
        </UserContext.Provider>
    );
};

// Hook to access user data
export const useUser = () => useContext(UserContext);
